export const resourceMasterGridMaxSize = 580;

export const resourceGridRowHeight = 50;

export const resourceDetailGridPadding = 16;

export const resourceDetailGridMaxSize =
  resourceMasterGridMaxSize - resourceGridRowHeight - resourceDetailGridPadding;

export const getResourceGridSize = (
  resourcesCount: number,
  masterGrid?: boolean,
) => {
  const borders = resourcesCount + 1;

  const rowsHeight = resourcesCount * resourceGridRowHeight;

  const mainGridHeight =
    rowsHeight +
    borders +
    resourceGridRowHeight + // as header
    15; // as scrollbar;

  if (masterGrid) {
    return mainGridHeight;
  }

  const paddingsHeight = resourceDetailGridPadding * 2;
  const toolbarHeight = 30;

  return mainGridHeight + paddingsHeight + toolbarHeight;
};
